import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data?.session_token) {
          localStorage.setItem("hw_session_token", data.session_token);
        }
        setUser(data);
        // Clear hash
        window.history.replaceState({}, "", window.location.pathname);
        if (!data.role) {
          navigate("/onboarding", { replace: true, state: { user: data } });
        } else if (data.role === "admin") {
          navigate("/admin", { replace: true, state: { user: data } });
        } else if (data.role === "hotel_partner") {
          navigate("/partner", { replace: true, state: { user: data } });
        } else {
          navigate("/customer", { replace: true, state: { user: data } });
        }
      } catch (e) {
        console.error(e);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex items-center gap-3 text-slate-700">
        <span className="hw-pulse-dot" />
        <span className="hw-label">Securing your session</span>
      </div>
    </div>
  );
}
